import script from "./ScreenCaps.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenCaps.vue?vue&type=script&setup=true&lang=js"

import "./ScreenCaps.vue?vue&type=style&index=0&id=ac72ac6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac72ac6e"]])

export default __exports__